module.exports = __webpack_public_path__ + "img/kbi-bw.8bc95676.png";